import { UpdateDepressionInput } from 'types/graph';

import { DepressionFormValues } from '../form/types';

const buildInput = (values: DepressionFormValues): UpdateDepressionInput => {
  const input: UpdateDepressionInput = {
    diagnosedAt: values.diagnosedAt,
    severity: values.severity,
    currentlyTreated: values.currentlyTreated,
    hospitalized: values.hospitalized,
  };

  if (values.currentlyTreated) {
    input.numberOfMedications = values.numberOfMedications;
    input.psychotherapy = values.psychotherapy;
  } else {
    input.everTreated = values.everTreated;
    if (values.everTreated) {
      input.treatmentEndDate = values.treatmentEndDate;
    }
  }

  if (values.hospitalized) {
    input.hospitalizedAt = values.hospitalizedAt;
  }

  return input;
};

export default buildInput;
